'use client'

import { useHierarchicalMenu } from 'react-instantsearch'

type FilterHierarchicalMenuProps = {
  heading?: string
  attributes: string[]
}

const classNames = {
  list: 'w-full flex flex-col gap-y-xxxs s:gap-xxs',
  label: 'flex items-center gap-xxs',
  labelText:
    'block text-left font-normal text-17 s:text-14 hover:text-primary cursor-pointer transition-colors',
  count: 'sr-only',
  parentItem: '!font-bold',
}

export default function FilterHierarchicalMenu({
  heading,
  attributes,
}: FilterHierarchicalMenuProps) {
  const { items, refine } = useHierarchicalMenu({
    attributes,
    sortBy: ['name:asc'],
    limit: 999,
    showParentLevel: true,
    showMore: false,
  })

  return (
    <div className="mr-[-1px] mt-[-1px] flex flex-grow flex-col gap-xxs border-l border-r border-t border-border p-m ms:p-s ms-up:w-1/3 [&_ul_ul]:ml-s last:[&_ul_ul]:my-xxs">
      {heading ? <h6 className="mb-xxxs">{heading}</h6> : null}

      <FilterHierarchicalMenuList items={items} refine={refine} />
    </div>
  )
}

function FilterHierarchicalMenuList({ items, refine }) {
  return (
    <ul className="flex flex-col gap-xxs">
      {items.map((item) => {
        const active = item.isRefined
        const activeClass = active ? 'text-primary hover:text-black' : ''

        return (
          <li key={item.value} className={`block text-left ${activeClass}`}>
            <button className={classNames.label} onClick={() => refine(item.value)}>
              <input type="checkbox" checked={active} readOnly className="shrink-0" />
              <span className={classNames.labelText}>{item.label}</span>
            </button>

            {item.data && <FilterHierarchicalMenuList items={item.data} refine={refine} />}
          </li>
        )
      })}
    </ul>
  )
}
